import React from 'react'

import { Body1 } from '@ui/Typography/Typography'
import { IconButton } from '@ui/components/Button'
import { ChevronIcon } from '@ui/icons/Chevron.icon'

import { NameDto } from '@model/NameDto'

import { Box } from '@shared/components/Box'

type SortOrder = 'ASC' | 'DESC'

export interface ModalBodyTableSortProps {
  options: (NameDto<string> | string)[]
  onConfirm: (option: string, sortBy: SortOrder, sortName: string) => void
}

export const ModalBodyTableSort: React.FC<ModalBodyTableSortProps> = (props) => {
  const { options, onConfirm } = props

  const normalizedOptions = options.map((option) =>
    typeof option === 'string' ? { id: option, name: option } : option
  )

  return (
    <Box fullWidth flex direction='column'>
      {normalizedOptions.map(({ name, id }) => (
        <Box flex py='x16' justify='space-between' gap='x24' align='center'>
          <Body1>{name}</Body1>
          <Box flex justify='flex-end' gap='x24' align='center'>
            <IconButton icon={ChevronIcon.Down} onClick={() => onConfirm(id, 'DESC', name)} />
            <IconButton icon={ChevronIcon.Up} onClick={() => onConfirm(id, 'ASC', name)} />
          </Box>
        </Box>
      ))}
    </Box>
  )
}
